export const baseUrlMiddleware = (instance) => {
    if (process.env.NODE_ENV === "development" && process.env.NOMOTEX_API) {
        instance.interceptors.request.use((request) => {
            request.baseURL = process.env.NOMOTEX_API;
            return request;
        });
    }
};
